import React from "react";

export default (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.41324 15.7657L0.232674 8.56562C-0.0775584 8.25361 -0.0775584 7.74639 0.232674 7.43438L7.41324 0.234307C7.72348 -0.0781019 8.22636 -0.0781018 8.53659 0.234307C8.84683 0.546316 8.84683 1.05353 8.53659 1.36554L2.71215 7.19998L14.2055 7.19998C14.6441 7.19998 15 7.55839 15 8C15 8.44161 14.6441 8.80002 14.2055 8.80002L2.71215 8.80002L8.53659 14.6345C8.69191 14.7905 8.76937 14.9953 8.76937 15.2001C8.76937 15.4049 8.69191 15.6097 8.53659 15.7657C8.22636 16.0781 7.72348 16.0781 7.41324 15.7657Z" fill="white"/>
  </svg>
);
